import React from "react";
import { Button, Input, Modal } from "antd";
import styles from "./CarDedication.module.css";
import carIcon from "../../../assets/images/car_rv.png";
import PlateNumberComponent from "../../../components/PlateNumberComponent";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";

const CarDedication = ({
  isModalOpen,
  setIsModalOpen,
  companyEmployeeCars,
  selectedCar,
  setSelectedCar,
  onSetCompanyEmployeeCar,
  onRemovePlate,
  data,
}) => {
  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setSelectedCar(null);
        }}
        footer={null}
        closable={true}
        bodyStyle={{
          paddingBottom: 8,
          paddingLeft: 0,
          paddingRight: 0,
        }}
        closeIcon={
          <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
        }
        title="تخصیص خودرو"
      >
        <div className="scroll vh-50">
          {!companyEmployeeCars.length && (
            <div
              className="flex flex-items-center flex-content-center"
              style={{ width: "100%" }}
            >
              <p className="color-red pt-10">No cars found</p>
            </div>
          )}
          {companyEmployeeCars.length > 0 &&
            companyEmployeeCars.map((item) => {
              return (
                <div
                  className="w-100 flex-column flex-content-center py-10 px-20 "
                  onClick={() => !data?.plate_number && setSelectedCar(item)}
                >
                  <div className={styles.CarItem}>
                    <div className={styles.CarIcons}>
                      {" "}
                      <Input
                        type="radio"
                        checked={
                          data?.plate_number
                            ? data?.plate_number === item.plate_number ||
                              (data.plate_number.number_plate_part_1 ===
                                item?.plate_number?.number_plate_part_1 &&
                                data.plate_number.number_plate_part_2 ===
                                  item.plate_number.number_plate_part_2 &&
                                data.plate_number.number_city_code ===
                                  item.plate_number.number_city_code &&
                                data.plate_number.number_plate_alphabet ===
                                  item.plate_number.number_plate_alphabet)
                            : selectedCar?.plate_number === item.plate_number
                        }
                      />
                      <img
                        src={carIcon}
                        alt="car icon"
                        className={styles.CarIcon}
                      />
                    </div>

                    <div className="flex flex-content-space-between w-100 ">
                      <div
                        className={`flex-items-center ${styles.CarName}`}
                        title={`${item.car.brand} ${
                          item.car.model
                            ? ` - ${(<span>{item.car.model}</span>)}`
                            : ""
                        }`}
                      >
                        <span>{item.car.brand}</span>{" "}
                        {item.car.model &&
                          ` - ${(<span>{item.car.model}</span>)}`}
                      </div>
                      <div className="flex-items-center flex-content-space-between">
                        <PlateNumberComponent data={item.plate_number} />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div
          className={`flex-row ${
            data.plate_number ? "flex-row-reverse" : ""
          } flex-content-space-between flex-items-center mx-15`}
        >
          {!data.plate_number && (
            <Button
              className="button-promotion w-45 mx-auto my-0 mt-15"
              onClick={() => onSetCompanyEmployeeCar(data.pk)}
            >
              Apply
            </Button>
          )}
          {data.plate_number && (
            <Button
              className={`mt-15 w-45 ${styles.DeletePlateNumberButton} mr-4`}
              onClick={() => onRemovePlate(data, true)}
            >
              Remove Plate
            </Button>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CarDedication;
